import { useInfiniteQuery, useQuery } from 'react-query';

import type { Order } from '~/api/model';
import { ORDER_QUERY_KEY } from '~/api/query-keys';

// Response 타입 (model에서 재노출)
export type {
  Delivery,
  Order,
  OrderDetail,
  OrderDetailProductBundle,
  OrderGift,
  OrderProductItem,
  OrderVendor,
  PaymentResult,
  VendorOrderDetailBundle,
} from '~/api/model';

/** 주문 내역 목록 (무한 스크롤) */
// GET /api/market-place/v1/orders
export const useInfiniteOrderHistories = () => {
  const { queryKey, queryFn } = ORDER_QUERY_KEY.histories();

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteQuery(queryKey, queryFn, {
      suspense: true,
      getNextPageParam: (lastPage) => {
        if (!lastPage.hasNextPage) return undefined;
        return lastPage.lastId;
      },
    });

  const pages = data?.pages?.reduce<Order[]>(
    (acc, page) => acc.concat(page.content),
    [],
  );

  return {
    pages,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  };
};

/** 주문 상세 조회 */
// GET /api/market-place/v2/orders/{orderId}/details
export const useOrderDetail = (orderId: number) => {
  const { queryKey, queryFn } = ORDER_QUERY_KEY.detail(orderId);

  return useQuery(queryKey, queryFn, {
    suspense: true,
    enabled: !!orderId && !Number.isNaN(orderId),
  });
};
